import AdsModal from './AdsModal';

export default AdsModal;
